import axios from 'axios'

export default {
  getChartPoints (apiPath, author, unit = 'mm', serieLabels = ['X', '5%', '50%', '95%']) {
    return new Promise((resolve, reject) => {
      let url = 'https://api.ultrahealth.care' + apiPath
      if (author) url += '?author=' + author
      axios.get(url)
        .then(res => {
          let chartData = [
            serieLabels
          ]
          // Ajusta a unidade de medida
          let mult = 1
          if (unit === 'cm') {
            mult = 0.1
          }
          // Verifica se as series tem os nomes personalizados
          if (serieLabels[0] === 'X') {
            res.data.forEach(p => {
              chartData.push([p['measure'], p['p5'] * mult, p['p50'] * mult, p['p95'] * mult])
            })
          } else {
            res.data.forEach(p => {
              let linePoints = []
              for (let i = 0; i < serieLabels.length; i++) {
                linePoints.push(p[i] * (i === 0 ? 1 : mult))
              }
              chartData.push(linePoints)
            })
          }
          resolve(chartData)
        })
        .catch(err => {
          console.error(err)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/ultracare.js